var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSleepStyleStomach(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.549,
    height: 94.869,
    viewBox: "0 0 35.549 94.869",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4879",
    "data-name": "Group 4879",
    transform: "translate(-1671.102 -468.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6992",
    "data-name": "Path 6992",
    d: "M147.046,399.153c-.175.224,1.425.636,1.425.636s-2.971-.044-3.5.021.676,1.131.6,1.073c-.233.3.57.807.7.791-.127.622.67.525.793.982,1.034.345,2.849-.215,3.613-.484l0,.012a15.052,15.052,0,0,1,3.623-.727,27.964,27.964,0,0,0-.13-3.03l-3.993,1.02c-.346-.632-2.961-.517-3.136-.294",
    transform: "translate(1538.425 103.783)",
    fill: "#ef8062"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6994",
    "data-name": "Path 6994",
    d: "M222.929,93.776s1.814,3.686,5.214,2.294,2.394-9.073.159-9.685-6.86,1.892-5.373,7.391",
    transform: "translate(1467.15 389.715)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6996",
    "data-name": "Path 6996",
    d: "M182.352,454.033l-.424,5.37,13-.141-.565-6.642Z",
    transform: "translate(1504.445 54.138)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6997",
    "data-name": "Path 6997",
    d: "M250.98,932.462l-3.61-2.353s.266,9.334-.276,9.694a5.007,5.007,0,0,0-1.385,1.323.99.99,0,0,0,.106,1.327l5.566,4.379c.314.233.811-.123.764-.548a21.925,21.925,0,0,0-1.21-2.739,9.621,9.621,0,0,0-.836-1.662c-.25-.389.88-9.421.88-9.421",
    transform: "translate(1446.201 -383.271)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6998",
    "data-name": "Path 6998",
    d: "M158.036,930.241l3.612-2.349s-.274,9.333.267,9.694a5.007,5.007,0,0,1,1.383,1.324.99.99,0,0,1-.108,1.327l-5.57,4.374c-.315.232-.811-.124-.763-.549a21.932,21.932,0,0,1,1.213-2.738,9.624,9.624,0,0,1,.837-1.661c.25-.389-.871-9.422-.871-9.422",
    transform: "translate(1527.414 -381.24)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6999",
    "data-name": "Path 6999",
    d: "M89.781,162.7c-.165-3.549-.631-10.394-2.733-12.288-1.809-1.63-7.862-3.639-9.571-3.459l-4.631.563.478-2.228-1.432-3.5s-9.549,1.273-10.345,4.138,5.73,9.549,7.321,10.5,2.626,5.268,2.626,5.268-.637,7.689,0,9,13.051,2.359,13.687.612a20.841,20.841,0,0,0,.427-4.756c.877-.347,1.709-.7,2.4-1a2.961,2.961,0,0,0,1.773-2.85",
    transform: "translate(1614.783 338.881)",
    fill: "#6aa1b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7001",
    "data-name": "Path 7001",
    d: "M145.858,511.975c-.716,1.708-2.626,13.905-2.745,17.686s.239,19.638,2.268,20.614,4.655-.732,4.655-.732l1.552-20.614s.477,19.638,1.194,20.37,3.581,3.049,4.894.488,2.745-17.808,2.984-21.712-.477-16.1-1.074-16.589-13.011-1.22-13.727.488",
    transform: "translate(1540.02 0.745)",
    fill: "#6aa1b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7002",
    "data-name": "Path 7002",
    d: "M22.812,52.193a7.5,7.5,0,0,1,1.954-2.282c1.389-1.1,2.941-3.24.627-6.523-3.582-5.083-8.284-1.942-12.109.235s-7.047-2.641-9.82-.687S-2.7,53.328,3.456,54.7s6.577-.034,9.252.328,5.877.335,8.117-.875a4.829,4.829,0,0,0,1.987-1.958",
    transform: "translate(1671.102 431.53)",
    fill: "#221e3f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4402",
    "data-name": "Rectangle 4402",
    width: 35.549,
    height: 94.869,
    transform: "translate(1671.102 468.766)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepStyleStomach);
export default __webpack_public_path__ + "static/media/sleepStyleStomach.30c723a15a860dd04565b35684be4b1f.svg";
export { ForwardRef as ReactComponent };